import { phoneToString } from '@debbie/common/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import CopyToClipboard from '../CopyToClipboard.js';
import { Edit, X } from '../Icons/index.js';
import UserPreview from '../UserPreview.js';
import UserType from '../UserType.js';
const User = (props) => {
    const history = useHistory();
    const { user } = props;
    const lang = useSelector((s) => s.lang);
    const redirect = (path) => {
        history.push(path);
    };
    if (!user) {
        return null;
    }
    return (React.createElement(Wrapper, { onClick: () => {
            if (props.onClick) {
                props.onClick(props.user);
            }
        } },
        React.createElement("div", { style: { flexGrow: 3, display: 'inline-flex', alignItems: 'center' } },
            React.createElement(UserPreview, { noTooltip: props.noTooltip, user: user, style: { marginRight: '7px' } }),
            React.createElement("div", { style: { display: 'block' } },
                React.createElement(Name, null,
                    React.createElement("b", null,
                        user.firstName,
                        " ",
                        user.lastName)),
                React.createElement(UserContactDetails, { user: user }))),
        React.createElement("div", { style: {
                float: 'right',
                display: 'inline-flex',
            } },
            user.details.meetingAccountType === 'meeting_only' ? null : (React.createElement(UserType, { role: user.role, style: { margin: `${THEME.GRID_SPACING}px` } },
                lang.roles[user.role],
                ' ')),
            React.createElement("div", { style: {
                    cursor: 'pointer',
                    right: `0px`,
                    top: '1px',
                    padding: `${THEME.GRID_SPACING}px`,
                    flexGrow: 1,
                    flexShrink: 3,
                }, onClick: () => {
                    return props.onRemove
                        ? props.onRemove()
                        : redirect(`/settings/users/${user.id}`);
                } }, props.onRemove ? React.createElement(X, null) : React.createElement(Edit, null)))));
};
export default User;
export const UserContactDetails = (props) => {
    const { user } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { flexGrow: 2 } },
            user.email && (React.createElement(CopyToClipboard, { text: user.email }, user.email.length > 20
                ? `${user.email.slice(0, 10)}(...)${user.email.slice(-10)}`
                : user.email)),
            user.phone && user.phone.number ? (React.createElement("span", { style: { marginLeft: '5px' } },
                "/",
                ' ',
                React.createElement(CopyToClipboard, { text: user.phone?.number ? phoneToString(user.phone) : '' }, user.phone && phoneToString(user.phone)))) : (''))));
};
const Wrapper = styled.div `
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
  padding: 0.5em;
  margin-bottom: 10px;
  background: #eee;
  border-radius: 5px;
  width: 100%;
`;
const Name = styled.p `
  margin: 0;
  display: inline-block;
`;
//# sourceMappingURL=User.js.map